import { where } from "firebase/firestore"
import { Collection, WhereField } from '../../shared/constants'
import { addDoc, deleteDoc, getAllDocsByClientId, getAllDocsByParkId, getAllDocsByQueries, getDocById, getDocByQueries, updateDoc } from './collectionBaseWorker'

export const getAllAccessCardsByClientId = async ({ clienteId }) => {
    return await getAllDocsByClientId({ collection: Collection.ACCESS_CARD, clienteId: clienteId })
}

export const getAllAccessCardsByParkId = async ({ estacionamentoId }) => {
    return await getAllDocsByParkId({ collection: Collection.ACCESS_CARD, estacionamentoId: estacionamentoId })
}

export const getAccessCardById = async ({ id }) => {
    return await getDocById({ collection: Collection.ACCESS_CARD, id: id })
}

export const getAllAccessCardsByReferenceId = async ({ referenceId, estacionamentoId }) => {
    return await getAllDocsByQueries({
        collection: Collection.ACCESS_CARD,
        queries: [
            where(WhereField.PARKID, "==", estacionamentoId),
            where(WhereField.REFERENCE_ID, "==", referenceId)
        ]
    })
}

export const getAccessCardByParkIdAndNumber = async ({ estacionamentoId, accessCard }) => {
    const newAccessCard = parseInt(accessCard).toString()
    if (isNaN(newAccessCard)) {
        return []
    }
    return await getDocByQueries({
        collection: Collection.ACCESS_CARD,
        queries: [
            where(WhereField.PARKID, "==", estacionamentoId),
            where(WhereField.CARD_NUMBER, "==", newAccessCard),
        ]
    })
}

export const getAllAccessCardsByClientIdAndNumber = async ({ clienteId, accessCard }) => {
    const newAccessCard = parseInt(accessCard).toString()
    if (isNaN(newAccessCard)) {
        return []
    }
    return await getAllDocsByQueries({
        collection: Collection.ACCESS_CARD,
        queries: [
            where(WhereField.CLIENTEID, "==", clienteId),
            where(WhereField.CARD_NUMBER, "==", newAccessCard)
        ]
    })
}

export const getAllAccessCardsOfAccreditedByParkId = async ({ estacionamentoId }) => {
    return await getAllDocsByQueries({
        collection: Collection.ACCESS_CARD,
        queries: [
            where(WhereField.PARKID, "==", estacionamentoId),
            where(WhereField.TYPE, "==", "accredited")
        ]
    })
}

export const addAccessCard = async ({ clienteId, estacionamentoId, referenceId, type, cardNumber }) => {
    const data = {
        clienteId: clienteId,
        estacionamentoId: estacionamentoId,
        referenceId: referenceId,
        type: type,
        cardNumber: parseInt(cardNumber).toString()
    }
    const doc = await addDoc({ collection: Collection.ACCESS_CARD, data: data })
    return doc.id;
}

export const updateAccessCard = async ({ id, data }) => {
    await updateDoc({ collection: Collection.ACCESS_CARD, id: id, data: data })
}

export const removeAccessCard = async ({ id }) => {
    var data = await getAccessCardById({ id: id })
    data.isDeleted = true
    await deleteDoc({ collection: Collection.ACCESS_CARD, id: id })
}
